// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".fondo{min-width:100%;min-height:100%;background-image:url(/images/spikes.png);background-repeat:repeat}", ""]);
// Exports
module.exports = exports;
